import { isLocalDevHost, shouldEnforceDomainSplit } from '../constants/siteDomains';

const COOKIE_NAME = 'constela_has_session';
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 30;

function cookieDomainAttribute(): string {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname;
  if (host.endsWith('constelabrasil.com.br')) {
    return '; domain=.constelabrasil.com.br';
  }
  return '';
}

function isSecureCookie(): boolean {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

/** Indica login ativo entre app.constelabrasil.com.br e constelabrasil.com.br. */
export function setSessionMarker(uid?: string): void {
  if (typeof document === 'undefined') return;
  const safeUid = uid && /^[A-Za-z0-9]{8,128}$/.test(uid) ? uid : '1';
  const secure = isSecureCookie() ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${safeUid}; path=/; max-age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax${secure}${cookieDomainAttribute()}`;
}

export function clearSessionMarker(): void {
  if (typeof document === 'undefined') return;
  const secure = isSecureCookie() ? '; Secure' : '';
  const expired = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secure}`;
  document.cookie = `${expired}${cookieDomainAttribute()}`;
  document.cookie = expired;
}

function readSessionMarkerValue(): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = `${COOKIE_NAME}=`;
  const part = document.cookie
    .split(';')
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));
  if (!part) return null;
  const value = decodeURIComponent(part.slice(prefix.length));
  return value || null;
}

export function hasSessionMarker(): boolean {
  return readSessionMarkerValue() !== null;
}

/** Uid gravado no cookie. Cookies antigos só têm "1" e não identificam a conta. */
export function readSessionUserId(): string | null {
  const value = readSessionMarkerValue();
  if (!value || value === '1' || !/^[A-Za-z0-9]{8,128}$/.test(value)) return null;
  return value;
}

/** Usuário logado nesta aba ou em outro subdomínio da Constela. */
export function hasCrossDomainSessionHint(isAuthenticated: boolean): boolean {
  if (isAuthenticated) return true;
  if (!shouldEnforceDomainSplit() || isLocalDevHost()) return false;
  return hasSessionMarker();
}
